import React from "react";
import Mydata from "@/app/data/Servies/city_tours.json";

function thirdSlider() {
  const data = Mydata[2];

  return (
    <div style={{ background: "rgba(213, 175, 52, 0.1)" }} className="px-4">
      <div className="mx-auto max-w-7xl pt-7 text-center ">
        <h2 className="text-4xl secondary  font-bold ">
          <span style={{ color: "#D5AF34" }}>{data.title}</span>
          <span style={{ color: "#2B3252" }}>{data.subtitle}</span>
        </h2>

     
        <div className="">
              <p
                dangerouslySetInnerHTML={{ __html: data.des }}
                className="updatedparapremu pt-6"
              ></p>
              {/* <p className="updatedparapremu pt-6">{data.des}</p> */}
            </div>

        <div className="pb-7"></div>
      </div>
    </div>
  );
}

export default thirdSlider;
